import React from "react";

import { useHistory } from "react-router-dom";

import { PostStatus, PostType } from "@hubcapp/types";
import { useQueryPosts } from "@hubcapp/hooks";
import News from "./News";

import { getUrlExtentionForNewsItem } from "./helpers";
import { useAuth } from "@hubcapp/context";
import { useTealium } from "../../../context/TealiumProvider/TealiumProvider";

const NewsStateProvider = () => {
  const {
    instructor: { id },
  } = useAuth();
  const { data, loading } = useQueryPosts(id, {
    limit: 5,
    status: PostStatus.Live,
    type: [PostType.News, PostType.Tech],
  });

  const history = useHistory();
  const { trackEvent } = useTealium();
  const handleNewsItemClick = (id: string, type: PostType) => {
    const urlExtention = getUrlExtentionForNewsItem(type);
    trackEvent({
      eventCategory: "Homepage",
      eventAction: "Interaction",
      eventLabel: `View ${type} Story`,
    });
    history.push(`/messages/${urlExtention}/${id}`);
  };

  const handleViewAllClick = () => {
    trackEvent({
      eventCategory: "Homepage",
      eventAction: "Interaction",
      eventLabel: "See All News",
    });
    history.push("/messages/news");
  };

  return (
    <News
      newsItems={data?.instructor?.posts}
      loading={loading}
      handleNewsItemClick={handleNewsItemClick}
      handleViewAllClick={handleViewAllClick}
    />
  );
};

export default NewsStateProvider;
